import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Добавление рынков")
const _hoisted_2 = { style: {"width":"100%","overflow":"auto","padding":"3px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Загрузить файл", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"color":"red","font-size":"1.5rem","text-align":"left"} }, "Все поля в файле обязательны для заполнения", -1)
const _hoisted_5 = { class: "upload-modal__footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Отмена")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Сохранить")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiTable = _resolveComponent("UiTable")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close'))),
    fullWidth: !!_ctx.newFile.file
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createVNode(_component_UiInput, {
          class: "upload-modal__upload-input",
          type: "file",
          label: "Выберите файл",
          inputId: "mall",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.newFile.file = $event.target.files[0]))
        }),
        (!!_ctx.filePreview.cols)
          ? (_openBlock(), _createBlock(_component_UiTable, {
              key: 0,
              cols: _ctx.filePreview.cols,
              rows: _ctx.filePreview.rows
            }, null, 8, ["cols", "rows"]))
          : _createCommentVNode("", true)
      ])
    ]),
    controlButtons: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Btn, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
          disabled: _ctx.newFile.loading
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_Btn, {
          type: "primary",
          size: "large",
          disabled: !_ctx.newFile.file || _ctx.newFile.loading,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.newFile.submit()))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _: 1
  }, 8, ["fullWidth"]))
}